import React, { RefObject } from 'react'
import jwt from 'jwt-decode'
import { FileUpload } from 'primereact/fileupload'
import { InputText } from 'primereact/inputtext'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'

import '../Assets/Css/DataTable.css'

interface IProps {
    HandleFileUpload: any,
    Costos: Array<object>,
    Loading: boolean,
    HandleSelectRow: any,
    Paginado : {
        NumeroPagina : number,
        RegistrosPagina : number,
        NumeroPaginas : number,
        fil_Mes: string,
        fil_Anio: number,
        fil_EAN: string,
        fil_Costo: number
    },
    HideModalFecha: any
}

interface IState {
    RefFile: RefObject<FileUpload>,
    GlobalFilter: string
}

export default class CostosPG extends React.Component<IProps, IState> {

    constructor(props : any){
        super(props)
        this.state = {
            RefFile: React.createRef<FileUpload>(),
            GlobalFilter: ''
        }
    }

    Header(){
        var Token : string | null = localStorage.getItem('TOKEN-UN1FL3X')
        if(Token){
            var Decoded : any = jwt(Token)
            var Origen =  "Costos"
            return(
                <div className="table-header">
                    <div className="table-header-left">
                        <span className="table-search">
                            <i className="pi pi-search" />
                            <InputText
                                value={this.state.GlobalFilter}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.setState({GlobalFilter: e.target.value})}
                                placeholder="Buscar en todas las columnas..."
                                className="table-search-input"
                            />
                        </span>
                    </div>
                    <div className="table-header-right">
                        {Decoded.IsDocumento === 'True' &&
                            <FileUpload
                                ref={this.state.RefFile}
                                mode="basic"
                                name="file"
                                auto
                                uploadHandler={(Event) => this.props.HandleFileUpload(Event, this.state.RefFile, Origen)}
                                customUpload
                                accept=".xlsm,application/msexcel,.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                chooseLabel="Importar Costos"
                                className="table-upload-btn"
                            />
                        }
                    </div>
                </div>
            )
        }
    }

    BodyMes = (RowData : any) => {
        const mesNombre = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "octubre", "noviembre", "diciembre"];
        return mesNombre[RowData.Mes-1];
    }

    render(){
        return(
            <div className="table-wrapper">
                <DataTable
                    value={this.props.Costos}
                    selectionMode="single"
                    header={this.Header()}
                    className="p-datatable-customers"
                    loading={this.props.Loading}
                    emptyMessage="No se encuentra ningún costo registrado."
                    globalFilter={this.state.GlobalFilter}
                    scrollable
                    scrollHeight="calc(100vh - 270px)">
                        <Column field="Mes" body={this.BodyMes} header="Mes" style={{ minWidth: '120px' }}/>
                        <Column field="Anio" header="Año" style={{ minWidth: '100px' }}/>
                        <Column field="EAN" header="EAN" style={{ minWidth: '160px' }}/>
                        <Column field="Costo" header="Costo" style={{ minWidth: '120px' }}/>
                </DataTable>
            </div>
        )
    }
}
